import { CFTokens } from '../../../tokens';
export const BACKGROUND_HOVER = CFTokens.COLOR.BACKGROUND_WARM_1;
export const BACKGROUND_SELECTED = CFTokens.COLOR.BACKGROUND_WARM_2;
export const BACKGROUND_SELECTED_HOVER = CFTokens.COLOR.BACKGROUND_WARM_1;
export const COLOR = {
    CAPTION: 'text-and-element-hint',
    LABEL: 'text-and-element-hint',
    TITLE: 'text-and-element-default',
};
export const COLOR_DISABLED = {
    CAPTION: 'text-and-element-disabled',
    LABEL: 'text-and-element-disabled',
    TITLE: 'text-and-element-disabled',
};
export const DOT_COLOR_DISABLED = 'text-and-element-disabled';
export const DOT_COLOR_DEFAULT = 'transparent';
export const DOT_SIZE = 8;
export const INLINE_PADDING = CFTokens.SPACER.D;
